import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";

/*
 * @Author: Nanxing Xiang
 * @LastEditors: Nanxing Xiang
 * @Date: 2020-12-24 13:34:32
 * @LastEditTime: 2021-03-17 17:34:17
 * @Description:
 * @FilePath: \easylive-h5\src\utils\sleep\index.ts
 */
export default function sleep(time) {
  return new _Promise(function (resolve) {
    setTimeout(function () {
      resolve(true);
    }, time);
  });
}